export default "__VITE_ASSET__DRQCZrtA__"